import styled from '@emotion/styled';
import { Paragraph as DefaultParagraph } from 'roo-ui/components';
import { H3 as DefaultH3 } from '../../primitives';

export const H3 = styled(DefaultH3)`
  font-size: 16px;
`;

export const Paragraph = styled(DefaultParagraph)`
  > p,
  ul {
    margin: 8px 4px;
  }
`;
